export default "__VITE_ASSET__gJma3MHE__"